/**
 * 一般性动作动画
 */
import fvAnimation from "./fvAnimation"
export default class fvGeneralOperation extends fvAnimation {
    constructor(shape){
        super(shape,"fvGeneralOperation");
        if(this.startExpression){
            this.startExpression = AsyncFunction(this.startExpression)
        }
        if(this.cycleExpression){
            this.cycleFunction =  AsyncFunction(this.cycleExpression);
        }
        this.lastTime = Date.now();
        this.isStart = false;
    }

    run(canvas,value){
        //if(value == false) return;
        if(!this.isStart){
            this.isStart = true;
            this.executionScript(this.startExpression);
        }
        var currTime = Date.now();
        if(currTime - this.lastTime > 1000 && this.cycleFunction){
            this.executionScript(this.cycleFunction);
            this.lastTime = currTime;
        }
    }

}


// WEBPACK FOOTER //
// ./src/js/canvas/animation/fvGeneralOperation.js